
const TreeInfoHistoryView = (props) => {

    return (
        <div></div>
    )

}

export default TreeInfoHistoryView
